import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { BasicTable, MASK_DATE } from "../../../../../../theme/Component/BasicTable";
import { _FixedAssetItem } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { _AssignedMaintenanceType, _DocumentFactory, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import useModal, { MODAL_XL } from "../../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ErrorList } from "../../../../../../theme/Component/ErrorList";
import { DocumentViewer } from "../../../../../../theme/Component/DocumentViewer";

interface Props {
    idItem: number;
}

export const FixedAssetReplacement = ({ idItem }: Props) => {
    const { instance, lista, bean, setBean, setLista } = useDataBean(_FixedAssetItem)
    const modal = useModal("Documento Contable", MODAL_XL);
    const doc = useDataBean(_DocumentFactory);

    useEffect(() => {
        getLista();
    }, [idItem])

    const getLista = () => {
        instance.getFixedAssetReplacementCatalogByItem(idItem).then(
            (resp: any) => {
                resp.forEach(element => {
                    const obj = element.DataBeanProperties;
                    obj.EntityDoc = `${obj.Consecutive ? `${obj.Mnemonic} - ${obj.Consecutive}` : "N/A"}`
                });
                setLista(resp);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDFixedAssetReplacement', visible: true },
        { title: 'Documento', property: 'EntityDoc', visible: true },
        { title: 'Fecha Documento', property: 'DocumentDate', visible: true, mask: MASK_DATE },
        { title: 'IDProducto', property: 'IDProduct', visible: true },
        { title: 'Código Producto', property: 'ProductCode', visible: true },
        { title: 'Nombre Producto', property: 'Description', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },
    ]

    const [msgList, setMsgList] = useState<any>([]);

    const listaBotones = () => {
        const botones = [
            {
                titulo: 'Ver Documento', icono: 'ri-eye-line', visible: true, evento: () => {
                    doc.instance.getAccountantDocumentByLocation(bean.IDDocument, bean.Since).then(
                        (resp) => {

                            doc.setLista(resp.DocumentURL)
                            modal.open()
                            setMsgList(resp.MsgList);
                        }
                    )
                }
            },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />
                <Modal modal={modal.modal} updateModal={modal.setModal} >
                    <div className="row">
                        <div className="col">
                            {msgList.length > 0 &&
                                <ErrorList lista={msgList} />
                            }
                            {msgList.length === 0 && lista.length > 0 &&
                                <DocumentViewer key={doc.lista} list={doc.lista} />
                            }
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}